module.exports = __webpack_public_path__ + "img/to-bookmarks.624fb4a3.svg";